<template>
    <div>
        <psi-page-title
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
        ></psi-page-title>
        <!-- Content always starts with a v-card  -->
        <v-card class="mt-4" height="700">
            <v-card-text>
                <h4 class="mb-2">Admin Company</h4>
                <v-divider></v-divider>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    name: "application-colors",
    data() {
        return {
            page: {
                title: "Admin Company",
                icon: "mdi-city",
            },
            breadcrumbs: [
                {
                    text: "Admin",
                    disabled: false,
                    to: "#",
                },
                {
                    text: "Admin Company",
                    disabled: true,
                },
            ],
        };
    },
    mounted() {
        this.$toast({
            content: "Example Snackbar Message",
        });
    },
};
</script>

<style scoped>
</style>